// extracted by mini-css-extract-plugin
export default {"homepage":"uX1loPVNRTk8j9VgmdWu"};